const sharedTokens = {
  "--color-transparent": "transparent",
  "--surface-white": "#FFFFFF",
  "--ink-black": "#000000",
  "--brand-universal": "#C75000",
  "--ink-primary": "#231F20",
  "--surface-dark": "#1C1B1C",
  "--surface-dark-alt": "#242424",
  "--border-subtle": "#BCBEC0",
  "--border-light": "#EAEAEA",
  "--surface-muted": "#F3F3F3",
  "--ink-secondary": "#505050",
  "--ink-muted": "#8A8C8C",
  "--ink-faint": "#9A9EA6",
  "--success": "#1DC542",
  "--accent-blue": "#2563EB",
  "--accent-cyan-bright": "#19FFFF",
  "--accent-cyan": "#1DD3D3",
  "--accent-teal-1": "#0EB9BF",
  "--accent-teal-2": "#0A888C",
  "--accent-teal-3": "#06575A",
  "--accent-teal-4": "#033133",
};

const generatedTokens = {
  "--token-005b99": "#005B99",
  "--token-453232": "#453232",
  "--token-5495b5": "#437D9A",
  "--token-e71a1a": "#E71A1A",
  "--token-063b6d": "#063B6D",
};

const lightTheme = {
  ...sharedTokens,
  ...generatedTokens,
  "--theme-name": "light",
  "--theme-surface-page": "var(--surface-white)",
  "--theme-surface-card": "var(--surface-white)",
  "--theme-surface-muted": "var(--surface-muted)",
  "--theme-surface-soft": "var(--surface-white)",
  "--theme-surface-dark": "var(--surface-dark)",
  "--theme-text-primary": "var(--ink-primary)",
  "--theme-text-secondary": "var(--ink-secondary)",
  "--theme-text-tertiary": "var(--ink-secondary)",
  "--theme-text-inverse": "var(--surface-white)",
  "--theme-border-primary": "var(--ink-black)",
  "--theme-border-muted": "var(--border-light)",
  "--theme-brand-universal": "var(--brand-universal)",
  "--theme-gradient-cta": "var(--brand-universal)",
  "--theme-gradient-cta-alt": "var(--brand-universal)",
  "--theme-gradient-dark": "var(--surface-dark)",
  "--theme-gradient-cyan": "var(--accent-cyan)",
};

const darkTheme = {
  ...sharedTokens,
  ...generatedTokens,
  "--theme-name": "dark",
  "--theme-surface-page": "var(--surface-dark)",
  "--theme-surface-card": "var(--surface-dark-alt)",
  "--theme-surface-muted": "var(--surface-dark-alt)",
  "--theme-surface-soft": "var(--ink-primary)",
  "--theme-surface-dark": "var(--surface-dark)",
  "--theme-text-primary": "var(--surface-white)",
  "--theme-text-secondary": "var(--border-subtle)",
  "--theme-text-tertiary": "var(--border-light)",
  "--theme-text-inverse": "var(--ink-primary)",
  "--theme-border-primary": "var(--surface-white)",
  "--theme-border-muted": "var(--border-subtle)",
  "--theme-brand-universal": "var(--brand-universal)",
  "--theme-gradient-cta": "var(--brand-universal)",
  "--theme-gradient-cta-alt": "var(--brand-universal)",
  "--theme-gradient-dark": "var(--surface-dark)",
  "--theme-gradient-cyan": "var(--accent-cyan)",
};

const themes = { light: lightTheme, dark: darkTheme };
const defaultThemeName = "light";

function serializeThemeVariables(themeName = defaultThemeName) {
  const theme = themes[themeName] || themes[defaultThemeName];
  return Object.entries(theme).map(([name, value]) => `${name}: ${value};`).join("\n");
}

function getThemeCssText(themeName = defaultThemeName) {
  return `:root {\n${serializeThemeVariables(themeName)}\n}`;
}

function applyTheme(themeName = defaultThemeName) {
  if (typeof document === "undefined") return;
  const theme = themes[themeName] || themes[defaultThemeName];
  const root = document.documentElement;
  root.dataset.theme = themeName;
  Object.entries(theme).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
}

const manifestColors = {
  backgroundColor: lightTheme["--surface-white"],
  themeColor: lightTheme["--brand-universal"],
};

module.exports = {
  sharedTokens,
  themes,
  defaultThemeName,
  manifestColors,
  serializeThemeVariables,
  getThemeCssText,
  applyTheme,
};
